module.exports = __webpack_public_path__ + "img/terracesnow.776fb8fc.jpg";